import React from "react";
import { CtaButton } from "./CtaButton";
import { CountdownTimer } from "./CountdownTimer";
import { Reveal } from "./Reveal";
import { DownloadIcon, CreditCardIcon, InfinityIcon, ShieldCheckIcon } from "lucide-react";
const MOCKUP = "https://cdn.magicpatterns.com/uploads/4RsDhtXkLnNBaQCZhikKke/MOCKUP_PRINCIPAL_SALES.png";
const badges = [{
  icon: DownloadIcon,
  label: "Descarga inmediata"
}, {
  icon: CreditCardIcon,
  label: "Pago único"
}, {
  icon: InfinityIcon,
  label: "Acceso de por vida"
}, {
  icon: ShieldCheckIcon,
  label: "Garantía de 7 días"
}];
export function Hero({
  ctaAnchorId
}: {
  ctaAnchorId: string;
}) {
  return <header className="relative w-full overflow-hidden bg-[#fbf5f0] px-5 pb-14 pt-10 sm:pt-14" data-id="element-106" data-mp="s9giq56neqat">
      <div className="mx-auto flex max-w-xl flex-col items-center text-center" data-id="element-107" data-mp="nbyhz22sbhdw">
        <Reveal data-id="element-108" data-mp="3d2bj5ngruvuh">
          <p className="mb-4 text-xs font-extrabold uppercase tracking-[0.3em] text-[#a04a63]" data-id="element-109" data-mp="3d2tpjcx5eqg4">
            Kit Digital
          </p>
        </Reveal>

        <Reveal delay={0.05} data-id="element-110" data-mp="3j7zc59vbxccg">
          <h1 className="font-serif-display text-[2rem] font-semibold leading-[1.08] text-[#3d2b30] sm:text-5xl" data-id="element-111" data-mp="3j924znc7pov0">
            Lanza tu propia línea de{" "}
            <span className="italic text-[#a04a63]" data-id="element-112" data-mp="39al869qleg11">sales de baño</span> en solo 7 días
          </h1>
        </Reveal>

        <Reveal delay={0.1} data-id="element-113" data-mp="3e8mt707kwpf5">
          <p className="mt-5 text-base leading-relaxed text-[#6b565b] sm:text-lg" data-id="element-114" data-mp="3e7uzxw1gf3s1">
            Aprende paso a paso cómo crear una colección con apariencia profesional, lista
            para presentar al mundo — aunque hoy no tengas experiencia, marca ni sepas por
            dónde empezar.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-8 w-full" data-id="element-115" data-mp="2qi0kd6pr3143">
          <img src={MOCKUP} alt="Kit Lanza tu Línea de Sales de Baño: 6 tomos digitales, plantillas y bonos" className="mx-auto w-full max-w-md drop-shadow-2xl" data-id="element-116" data-mp="2vjzmyedo1tzz" />
        </Reveal>

        <Reveal delay={0.2} className="mt-8 w-full" data-id="element-117" data-mp="2ljz1omw8l3t5">
          <p className="mb-2 text-xs font-bold uppercase tracking-widest text-[#a04a63]" data-id="element-118" data-mp="s2b921mmap6q">
            Presentamos
          </p>
          <p className="font-serif-display text-xl font-semibold text-[#3d2b30] sm:text-2xl" data-id="element-119" data-mp="najivs7dilh4">
            Kit Lanza tu Línea de Sales de Baño™
          </p>
          <p className="mt-3 text-sm leading-relaxed text-[#6b565b] sm:text-base" data-id="element-120" data-mp="ddf44dfuxsac">
            El sistema completo que te guía desde la primera idea hasta una línea de
            productos lista para mostrar con orgullo.
          </p>
        </Reveal>

        <Reveal delay={0.25} className="mt-8 w-full" data-id="element-121" data-mp="162m0p6vr47sy">
          <div id={ctaAnchorId} data-id="element-122" data-mp="1126mkd3naw9x">
            <CtaButton data-id="element-123" data-mp="111507ch6incw">✨ Quiero lanzar mi línea ✨</CtaButton>
          </div>
        </Reveal>

        <Reveal delay={0.3} className="mt-6 w-full" data-id="element-124" data-mp="x0crqlg4smho">
          <CountdownTimer data-id="element-125" data-mp="3lsp2bagmmdcu" />
        </Reveal>

        <Reveal delay={0.35} className="mt-6 w-full" data-id="element-126" data-mp="3ltqghnsxvfys">
          <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-127" data-mp="3hrlkiif0q78z">
            {badges.map(b => <li key={b.label} className="flex items-center gap-1.5 text-xs font-semibold text-[#6b565b]" data-id="element-128" data-mp="1xa43telg8kjm">
                <b.icon className="h-3.5 w-3.5 text-[#a04a63]" data-id="element-129" data-mp="21bxz17cvkwce" />
                {b.label}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </header>;
}